import Vue from 'vue'

import {
  addContainerWidgetSchema,
} from '@/components/form-designer/widget-panel/widgetsConfig'


import CardWidget from './card-widget'
import CardItem from './card-item'

import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister'
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory'
import { registerCWGenerator } from '@/utils/sfc-generator'
import { buildClassAttr, buildContainerWidget, buildFieldWidget } from '@/utils/sfc-generator'

export const cardTemplateGenerator = function (cw, formConfig) {
  const wop = cw.options
  //const headerAttr = `header="${wop.label}"`
  const classAttr = buildClassAttr(cw)
  const styleAttr = wop.cardWidth ? `style="{width: ${wop.cardWidth} !important}"` : ''
  const shadowAttr = `shadow="${wop.shadow}"`
  const vShowAttr = wop.hidden ? `v-show="false"` : ''

  const cardTemplate =
    `<div class="card-container">
  <el-card ${classAttr} ${styleAttr} ${shadowAttr} ${vShowAttr}>
    <div slot="header" class="clear-fix">
      <span>${wop.label}</span>
      ${wop.showFold ? `<i class="float-right el-icon-arrow-down"></i>` : ''}
    </div>
    ${cw.widgetList.map(wItem => {
      if (wItem.category === 'container') {
        return buildContainerWidget(wItem, formConfig)
      } else {
        return buildFieldWidget(wItem, formConfig)
      }
    }).join('')
    }
  </el-card>
</div>`

  return cardTemplate
}


/**
 * 加载容器组件步骤：
 * 1. 加载组件Json Schema;
 * 2. 全局注册容器组件，容器组件有两种状态——设计期和运行期，故需要注册两个组件；
 * 3. 全局注册属性编辑器组件（基本属性、高级属性、事件属性）；
 * 4. 注册容器组件的代码生成器；
 * 5. 加载完毕。
 */
addContainerWidgetSchema({
  type: 'card',
  category: 'container',
  icon: 'card',
  widgetList: [],
  options: {
    name: '',
    label: 'card',
    hidden: false,
    folded: false,
    showFold: true,
    cardWidth: '100%',
    shadow: 'never',
    slotName: '',
    customClass: '',
    isShowCheckBox: false,
    cardTopButton: [],
    checkBoxChange: '',
    onCreated: '',
    onMounted: '',

  }
})  //加载组件Json Schema
/* -------------------------------------------------- */
Vue.component(CardWidget.name, CardWidget)  //注册设计期的容器组件
Vue.component(CardItem.name, CardItem)  //注册运行期的容器组件
/* -------------------------------------------------- */
PERegister.registerCPEditor('card-folded', 'card-folded-editor',
  PEFactory.createBooleanEditor('folded', 'extension.setting.cardFolded'))

PERegister.registerCPEditor('card-showFold', 'card-showFold-editor',
  PEFactory.createBooleanEditor('showFold', 'extension.setting.cardShowFold'))

PERegister.registerCPEditor('card-cardWidth', 'card-cardWidth-editor',
  PEFactory.createInputTextEditor('cardWidth', 'extension.setting.cardWidth'))

PERegister.registerCPEditor('card-slotName', 'card-slotName-editor',
  PEFactory.createInputTextEditor('slotName', '插槽名称'))

PERegister.registerCPEditor('cardTopButton', 'cardTopButton-editor',
  PEFactory.createInputTextEditor('cardTopButton', '按钮'))

PERegister.registerCPEditor('isShowCheckBox', 'isShowCheckBox-editor',
  PEFactory.createBooleanEditor('isShowCheckBox', '是否显示复选框'))

PERegister.registerEPEditor('checkBoxChange', 'checkBoxChange-editor',
  PEFactory.createEventHandlerEditor('checkBoxChange', ['val']))


let shadowOptions = [
  { label: 'never', value: 'never' },
  { label: 'hover', value: 'hover' },
  { label: 'always', value: 'always' },
]
PERegister.registerCPEditor('card-shadow', 'card-shadow-editor',
  PEFactory.createSelectEditor('shadow', 'extension.setting.cardShadow',
    { optionItems: shadowOptions }))
/* -------------------------------------------------- */
registerCWGenerator('card', cardTemplateGenerator)  //注册容器组件的代码生成器
   /* -------------------------------------------------- */
/* 容器组件加载完毕 end */